import {
  apiLoadCategories
} from '../api/apiObservables';
import apiHelper from '../../utilities/apiObsHelpers'

export const GETTER_CATEGORIES = 'analytics/getCategories';
export const GETTER_CATEGORIES_OBJ = 'analytics/getCategories';

export const MUTATE_SET_CATEGORIES = 'analytics/mutateCategories';
export const ACTION_LOAD_CATEGORIES = 'analytics/loadCategories';

const state = {
  categories: []
};

const getters = {
  [GETTER_CATEGORIES]: (state) => state.categories
  //[GETTER_CATEGORIES_OBJ]: (state) => state.categories.reduce((acc,v)=> {acc[v.name] = v; return acc;}, {} )
};

const mutations = {
  [MUTATE_SET_CATEGORIES]: (state, payload) => {
    state.categories = payload
  }
}

const actions = {
  [ACTION_LOAD_CATEGORIES]: apiHelper.mutateResult(apiLoadCategories, MUTATE_SET_CATEGORIES)
};

export default {
  state,
  getters,
  mutations,
  actions
}